import {useAuthContext} from "../../common/context/authContext";
import {useRouteMatch} from "react-router-dom";
import {Log} from "../../common/log";
import VerticalNav, {VerticalNavEntries, VerticalNavEntry, VerticalNavSection, VerticalNavTitle} from "../../common/slds/verticalNavigation/verticalNavigation";
import Url from "../../common/url";
import React from "react";
import PropTypes from "prop-types";

export function DeviceTypesNav(props) {
    const {deviceTypes, baseUrl, showAll} = props;
    const auth = useAuthContext();
    const match = useRouteMatch();

    Log.Debug("match", match);


    return <VerticalNav>
        <VerticalNavSection>
            <VerticalNavTitle>Device Types</VerticalNavTitle>
            <VerticalNavEntries>
                {showAll ? <VerticalNavEntry key={"all"} to={Url.join(baseUrl, "all")}>All</VerticalNavEntry> : null}
                {deviceTypes?.map((deviceType, i) => {
                        return <VerticalNavEntry
                            key={i}
                            to={Url.join(baseUrl, deviceType.id)}
                        >
                            {deviceType.displayName}
                        </VerticalNavEntry>;
                    }
                )}
            </VerticalNavEntries>
        </VerticalNavSection>
    </VerticalNav>;
}

DeviceTypesNav.propTypes = {
    baseUrl: PropTypes.string.isRequired,
    deviceTypes: PropTypes.array,
    showAll: PropTypes.bool,
};